.profileSettingsContainer {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  /* padding: 2rem; */
  box-sizing: border-box;
}

.divider {
  width: 100%;
  height: 1px;
  background: var(--static-divider-standard);
  margin: 30px 0;
}

.space {
  width: 100%;
  height: 1px;
  margin-top: 20px;
}

.profileHeader {
  color: var(--static-text-strong);
  font-size: 24px;
  margin-bottom: 30px;
  font-weight: 500;
}

.settingContainer {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  box-sizing: border-box;
}

.settingLabelContainer {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  box-sizing: border-box;
  padding: 0 15px 0 0;
  max-width: 19.5rem;
  min-width: 19.5rem;
}

.settingControlsContainer {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  box-sizing: border-box;
  padding: 1.25rem;
  background: var(--static-background-standard);
  border: 1px solid var(--static-divider-standard);
  border-radius: 0.75rem;
  width: 100%;
}

.settingButtonContainer {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  box-sizing: border-box;
  gap: 1rem;
  width: 100%;

}

.settingLabelHeaderText {
  color: var(--static-text-strong);
  font-weight: 500;
  line-height: 24px;
  margin-bottom: 10px;
}

.settingLabelSubText {
  color: var(--static-text-weak);
  font-weight: 500;
  font-size: var(--fs-small);
  line-height: 20px;
}

.settingControlsLabel {
  color: var(--static-text-strong);
  font-weight: 500;
  font-size: var(--fs-small);
  margin-bottom: 10px;
}

.linkedContainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  border: 1px solid var(--static-divider-standard);
  border-radius: 0.75rem;
  padding: 1.25rem;
  width: 100%;
}

.sellerInfoContainer {
  display: flex;
  justify-content: center;
  align-items: center;
}

.amazonIconContainer {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
}

.activeDot {
  position: absolute;
  bottom: -3px;
  right: -3px;
  width: 16px;
  height: 16px;
  background: var(--sentiment-text-positive);
  border: 3px solid var(--static-background-standard);
  border-radius: 10px;
}

.amazonIcon {
  width: 30px;
  border-radius: 8px;
}

.sellerInfoTextContainer {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  box-sizing: border-box;
  margin-right: 10px;
}

.sellerInfoText {
  color: var(--static-text-strong);
}

.marketplaceInfoText {
  color: var(--static-text-weak);
  font-size: var(--fs-small);
}

.readonlyInput:hover .pencilIcon {
  display: inline-block;
}

.readonlyInput:hover {
  cursor: pointer;
}

.pencilIcon {
  display: none;
  color: var(--static-text-strong);
}

.invalidText {
  color: var(--sentiment-text-negative);
}

.logoutContainer {
  margin-top: 10px;
}